interface MaskCredentialOptions {
    prefixLength?: number;
    suffixLength?: number;
}

/** Prevents a one-time credential from remaining in list state after disclosure. */
export function maskCredential(
    value: string | undefined,
    { prefixLength = 8, suffixLength = 4 }: MaskCredentialOptions = {},
) {
    if (!value) {
        return '';
    }

    if (value.length <= prefixLength + suffixLength) {
        return '•'.repeat(Math.max(value.length, 8));
    }

    return `${value.slice(0, prefixLength)}...${value.slice(-suffixLength)}`;
}
